module.exports = __webpack_public_path__ + "img/momsinla_app.27cc9a42.png";